import { render, staticRenderFns } from "./QA.vue?vue&type=template&id=ee2c31ee&scoped=true&"
import script from "./QA.vue?vue&type=script&lang=js&"
export * from "./QA.vue?vue&type=script&lang=js&"
import style1 from "./QA.vue?vue&type=style&index=1&id=ee2c31ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2c31ee",
  null
  
)

export default component.exports